/** ng serve :4200 — API domínio local; SSO e RBAC remotos (api-dev). */
const urlAplicacao = 'http://localhost:4200';
const apiLocal = 'http://localhost:8000';
const apiRemota = 'https://api-dev.ceiufg.com.br';

export const environment = {
  production: false,
  apiUrl: apiLocal,
  urlBaseApiAutorizacao: apiRemota,
  sso: {
    urlBaseServicoSSO: 'https://sso-dev.ceiufg.com.br',
    pathLogin: '/login',
    pathLogout: '/auth/logout/',
    redirectUriPosLogout: 'http://localhost:4200/',
    urlBaseAplicacaoCliente: urlAplicacao,
  },
  refreshToken: {
    url: 'https://api-dev.ceiufg.com.br/token/refresh/',
    intervaloSolicitacoes: 1_500_000,
  },
};
